<template>
    <span class="ui-hover" @mouseover="mouseover" @mouseleave="mouseleave">
        <slot></slot>
        <span class="ui-hover--svg" ref="el"></span>
    </span>
</template>

<script>
import lottie from 'lottie-web';
// https://airbnb.io/lottie/#/web

export default {
    name: 'link-hover',

    props: {
        current: false,
    },

    data() {
        return {
            anim: null,
            params: {},
            ann: { "v": "5.9.0", "fr": 29.9700012207031, "ip": 0, "op": 120.0000048877, "w": 284, "h": 108, "nm": "Highlight loop", "ddd": 0, "assets": [], "layers": [{ "ddd": 0, "ind": 1, "ty": 4, "nm": "Shape Layer 1", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [142, 54, 0], "ix": 2, "l": 2 }, "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 27.717], [-77.159, 0], [0, -28.804], [73.12, -1.672]], "o": [[-73.119, -1.672], [0, -28.804], [77.159, 0], [0, 27.717], [0, 0]], "v": [[-8.672, 52.106], [-139.708, 0.049], [0, -52.106], [139.708, 0.049], [8.672, 52.106]], "c": false }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "tm", "s": { "a": 1, "k": [{ "i": { "x": [0.204], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 15, "s": [0] }, { "t": 30.0000012219251, "s": [100] }], "ix": 1 }, "e": { "a": 1, "k": [{ "i": { "x": [0.468], "y": [1] }, "o": { "x": [0.577], "y": [0] }, "t": 0, "s": [0] }, { "t": 15.0000006109625, "s": [100] }], "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 4, "ix": 5 }, "lc": 1, "lj": 1, "ml": 4, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Shape 1", "np": 4, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 31.0000012626559, "st": 0, "bm": 0 }], "markers": [{ "tm": 0, "cm": "{\r\"name\":\"Open\"\r}", "dr": 15.0000006109625 }, { "tm": 15.0000006109625, "cm": "{\r\"name\":\"Close\"\r}", "dr": 16.0000006516934 }] }
        }
    },

    methods: {
        mouseover() {
            if (!this.current) this.anim.playSegments([1, 15], true);
        },

        mouseleave() {
            if (!this.current) this.anim.playSegments([15, 31], true);
        },
    },

    mounted() {
        this.params = {
            container: this.$refs.el,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            rendererSettings: {
                preserveAspectRatio: 'none'
            },
            animationData: this.ann
        };

        this.anim = lottie.loadAnimation(this.params);
        if (this.current) this.anim.goToAndStop(15, true);
    },
}
</script>

<style lang="scss">
.ui-hover {
    position: relative;
    cursor: pointer;

    svg {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 130%;
        pointer-events: none;
    }
}
</style>